import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Axios from "axios";

@Module({
  namespaced: true,
})
export default class Notification extends VuexModule {
  public allNotifications = [];
  public isModalShow = false;
  public orderNotification = {};
  public currentOrderDetails = {};

  @Action
  public async setAllNotifications(payload) {
    try {
      this.context.commit("setAllNotification", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async openNotificationModal(payload) {
    try {
      if (this.isModalShow) {
        await this.context.commit("setNotificationModal", false);
        this.context.commit("setNotificationModal", true);
      } else {
        this.context.commit("setNotificationModal", payload);
      }
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setNewOrdersNotification(payload) {
    try {
      this.context.commit("setNewOrderNotification", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getOrderDetails(payload) {
    try {
      let data: any = await Axios.get(payload);
      this.context.commit("setCurrentOrderDetails", data.data.response[0]);
      return data;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public setAllNotification(data: any) {
    this.allNotifications = data;
  }

  @Mutation
  public setNewOrderNotification(data: any) {
    this.orderNotification = data;
  }

  @Mutation
  public setNotificationModal(data: any) {
    if (this.isModalShow) {
      this.isModalShow = false;
      this.isModalShow = data;
    } else {
      this.isModalShow = data;
    }
  }

  @Mutation
  public setCurrentOrderDetails(data: any) {
    this.currentOrderDetails = data;
  }

  // getters
  get GetAllNotifications() {
    return this.allNotifications;
  }

  get GetNotificationModalState() {
    return this.isModalShow;
  }

  get GetNewOrderNotification() {
    return this.orderNotification;
  }

  get GetCurrentOrderDetails() {
    return this.currentOrderDetails;
  }
}
